import {Injectable} from '@angular/core';
import {ParamService} from './param.service';

@Injectable({
    providedIn: 'root',
})
export class FreshpassService {
    banner;

    public constructor(
        private paramService: ParamService,) {
          this.banner = this.paramService.banner;
    }

    getLocationHref() {
        return window.location.href;
    }

    getLocationHost() {
        return window.location.host;
    }

    getApplicationDomainURL() {
        let domain;
        if (this.getLocationHref().indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + this.getLocationHost();
        }
        return domain;
    }

    parseJwt(jwtToken) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    getUserClaims(user) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'],
            hid: oktaToken['hid'],
            zip: oktaToken['zip'],
            gid: oktaToken['gid'],
            uuid: oktaToken['uuid']
        };
        return userClaims;
    }
}
